import React, { useState, useEffect } from 'react';
// import { useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useForm, Controller } from 'react-hook-form';
import { useHistory, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Button } from '@mui/material';
import dayjs from 'dayjs';
import _ from 'lodash';
import axios from 'axios';
import AddProductForms from '../../components/Forms/Gold/AddProductForms';
import { ViewTitle } from '../../components/ViewTitle';
import * as actions from '../../redux/actions';
import TRANSACTION_TYPE from '../../utils/constants/transactionType.constant';
import useOrderCalculation from 'hooks/useOrderCalculation';
const Buy = ({ title, subtitle }) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const [listorder, setListorder] = useState([]);
  const [listproduct, setListproduct] = useState([]);
  const [materialName, setMaterialName] = useState('');
  const [noteMaterial, setNoteMaterial] = useState('');
  const [materialUnit, setMaterialUnit] = useState('');
  const [noMaterial, setNoMaterial] = useState('');
  const [placeName, setPlace] = useState('');
  const [materialTypeName, setmaterialTypeName] = useState('');
  const [materialTypeVat, setmaterialTypeVat] = useState('');
  const [goldPrice, setGoldprice] = useState(false);
  const [reload, setReload] = useState(false);
  const [payment, setPayment] = useState({});
  const [totalListOrder, setTotalListOrder] = useState();
  const [materialTypeId, setmaterialTypeId] = useState();
  const [transactionDate, setTransactionDate] = useState(null);
  const [image, setImage] = useState([]);
  const [saving, setSaving] = useState(false);

  const {
    control,
    formState: { errors },
    handleSubmit,
    reset,
    watch,
  } = useForm();

  const customer = location.state;
  const material = useSelector((state) => state.material);
  const materialType = useSelector((state) => state.materialType);
  const place = useSelector((state) => state.place);
  const bank = useSelector((state) => state.bank);

  const me = useSelector((state) => state.me);
  const history = useHistory();
  const GoldSell = parseFloat(
    (goldPrice?.price?.gold?.sell || '').replace(/,/g, ''),
  );
  const GoldBuy = parseFloat(
    (goldPrice?.price?.gold?.sell || '').replace(/,/g, ''),
  );
  const GoldBuyBar = parseFloat(
    (goldPrice?.price?.gold_bar?.sell || '').replace(/,/g, ''),
  );
  const GoldSellBar = parseFloat(
    (goldPrice?.price?.gold_bar?.buy || '').replace(/,/g, ''),
  );

  const { generateOrderData } = useOrderCalculation(
    listorder,
    TRANSACTION_TYPE?.BUY?.status_code,
  );
  const cashList = _.filter(bank?.rows, (b) => b.isCash === true);
  const totalCostListOrder = _.sumBy(
    listorder,
    (item) => Number(item.cost) || 0,
  );
  const remain =
    totalCostListOrder -
    (Number(watch('cash.amount')) || 0) -
    (Number(watch('transfer.amount')) || 0) -
    (Number(watch('credit.amount')) || 0);

  const handleAddOrder = async () => {
    if (saving) return;

    if (!window.confirm('ยืนยันการบันทึกสินค้า ?')) return;

    try {
      setSaving(true);

      // 💰 ยอดชำระรวม
      const totalPayment =
        (payment.cashStatus ? Number(payment?.cash) || 0 : 0) +
        (payment.transferStatus ? Number(payment?.transfer) || 0 : 0) +
        (payment.creditStatus ? Number(payment?.credit) || 0 : 0);

      if (totalPayment !== totalListOrder) {
        alert(
          `ยอดชำระ ${totalPayment} ไม่ตรงกับมูลค่ารวม ${totalListOrder} กรุณาตรวจสอบ`,
        );
        return;
      }

      // 🔧 เตรียมข้อมูลสินค้า
      const orderdatain = generateOrderData();

      // 📝 สร้าง payload ส่งไป backend
      const DataOrder = {
        date: transactionDate ? transactionDate : dayjs().format(),

        customer: {
          name: customer?.name || '',
          cardId: customer?.cardID || '',
          tel: customer?.tel || '',
          born: customer?.born || '',
          address: customer?.address || '',
          tax: { taxnumber: customer?.tax?.taxnumber || '' },
          social: {
            facebook: customer?.social?.facebook || '',
            line: customer?.social?.line || '',
            email: customer?.social?.email || '',
          },
          job: customer?.job || '',
        },

        saler: `${me?.userData?.firstname || ''} ${
          me?.userData?.lastname || ''
        }`,

        gold_transaction_type: TRANSACTION_TYPE?.BUY?.status_code,
        order: orderdatain,

        payment: {
          cash: {
            status: !!payment?.cashStatus,
            amount: Number(payment?.cash) || 0,
            bank: cashList?.[0]?._id || null,
          },
          transfer: {
            status: !!payment?.transferStatus,
            amount: Number(payment?.transfer) || 0,
            bank: payment?.bank?._id || null,
          },
          credit: {
            status: !!payment?.creditStatus,
            amount: Number(payment?.credit) || 0,
          },
        },

        goldprice: {
          date: dayjs().format(),
          update_time: goldPrice?.update_time,
          price: {
            gold: {
              buy: GoldSell,
              sale: GoldBuy,
            },
            gold_bar: {
              buy: GoldBuyBar,
              sale: GoldSellBar,
            },
          },
        },

        user: {
          id: me?.userData?._id,
          firstname: me?.userData?.firstname,
          lastname: me?.userData?.lastname,
        },

        place: {
          id: listorder?.[0]?.place || null,
        },
      };

      await dispatch(actions.goldTransactionCreate(DataOrder));
      alert('บันทึกสำเร็จ');
      history.push('/gold/gold');
    } catch (error) {
      if (error?.message === 'UPLOAD_FAILED') {
        alert(
          '❌ อัปโหลดรูปไม่สำเร็จ รูปภาพอาจจะมีขนาดใหญ่ลดขนาดและกรุณาลองใหม่อีกครั้ง',
        );
        return;
      }
      alert('เกิดข้อผิดพลาด: ' + (error?.message || 'ไม่ทราบสาเหตุ'));
    } finally {
      setSaving(false);
    }
  };

  const renderTitle = () => (
    <ViewTitle title={`${title}`} subtitle={subtitle} />
  );
  const handleBack = () => {
    history.goBack(); // Go back one step in history
  };
  useEffect(() => {
    dispatch(actions.materialAll({ name: '', page: 1 }));
    dispatch(actions.informationAll({ name: '', page: 1 }));
    dispatch(actions.bankAll({ name: '', page: 1 }));
    return () => {};
  }, []);
  useEffect(() => {
    try {
      axios.get('https://psu-thaigold.eappsoft.net/latest').then((res) => {
        setGoldprice(res.data?.response);
      });
    } catch (error) {
      console.error('Error', error?.message);
    }
    return () => {};
  }, [reload]);

  return (
    <div className="">
      {renderTitle()}
      <Box
        sx={{
          position: 'relative',
          padding: 1,
        }}
      >
        {/* ปุ่มกลับ */}
        <Button
          variant="outlined"
          sx={{
            position: 'relative',
            top: 6,
            right: 16,
            borderColor: 'red',
            color: 'red',
          }}
          onClick={handleBack}
        >
          กลับ
        </Button>{' '}
      </Box>
      <AddProductForms
        listorder={listorder}
        material={material}
        setListorder={setListorder}
        handleAddOrder={handleAddOrder}
        materialType={materialType}
        listproduct={listproduct}
        setListproduct={setListproduct}
        place={place}
        placeName={placeName}
        me={me}
        cashList={cashList}
        totalCostListOrder={totalCostListOrder}
        setPlace={setPlace}
        materialName={materialName}
        setmaterialTypeId={setmaterialTypeId}
        setMaterialName={setMaterialName}
        setNoteMaterial={setNoteMaterial}
        noteMaterial={noteMaterial}
        materialUnit={materialUnit}
        transactionDate={transactionDate}
        setTransactionDate={setTransactionDate}
        totalListOrder={totalListOrder}
        remain={remain}
        materialTypeId={materialTypeId}
        setTotalListOrder={setTotalListOrder}
        setMaterialUnit={setMaterialUnit}
        noMaterial={noMaterial}
        setNoMaterial={setNoMaterial}
        materialTypeName={materialTypeName}
        setmaterialTypeName={setmaterialTypeName}
        materialTypeVat={materialTypeVat}
        setmaterialTypeVat={setmaterialTypeVat}
        payment={payment}
        setPayment={setPayment}
        GoldBuyBar={GoldBuyBar}
        goldPrice={goldPrice}
        bank={bank?.rows || []}
        image={image}
        setImage={setImage}
      />
      <div className="flex flex-row justify-center  text-center">
        <Button variant="contained" onClick={() => handleAddOrder()}>
          {saving ? 'กำลังบันทึก...' : 'บันทึก'}
        </Button>
      </div>
    </div>
  );
};
Buy.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
};

Buy.defaultProps = {
  title: '',
  subtitle: '',
};

export default Buy;
